module.exports = __webpack_public_path__ + "static/media/send.62ef5be0.svg";